
// (function () {
//     pagination(false);
// })();

(function () {
    var head = document.querySelector('.gh-head');
    var burger = head.querySelector('.gh-burger');
    var body = document.getElementsByTagName("BODY")[0]; 
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!head.classList.contains('is-head-open')) {
            head.classList.add('is-head-open');
            body.classList.add('overflow-hidden');
        } else {
            head.classList.remove('is-head-open');
            body.classList.remove('overflow-hidden');
        }
    });
})();